export default "__VITE_ASSET__AjpugHZh__"